import { render, staticRenderFns } from "./DonorDetails.vue?vue&type=template&id=14ec3c04"
import script from "./DonorDetails.vue?vue&type=script&lang=js"
export * from "./DonorDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports